import React, { ReactElement, ReactNode } from 'react'
import { Video } from '../v2/components/Asset/Video'

interface Props {
  children: ReactNode
  video: {
    createdAt: string
    filename: string
    filesize: number
    id: string
    mimeType: string
    updatedAt: string
    url: string
  }
  darken?: boolean
  padding?: boolean
  overlayOpacity?: number
}
export default function HeroWithBackgroundVideo({
  darken,
  children,
  video,
  padding = true,
  overlayOpacity,
}: Props): ReactElement {
  return (
    <div
      className={`min-h-screen relative bg-heading ${padding ? 'py-24' : 'py-0'} overflow-hidden`}
    >
      {darken && <div className="absolute inset-0 bg-heading"></div>}
      <div
        style={{ opacity: overlayOpacity }}
        className="z-10 absolute inset-0 bg-gradient-to-b from-telesoft to-transparent mix-blend-soft-light"
      ></div>
      <div className="absolute z-0 inset-0 opacity-50">
        <Video
          video={{
            ...video,
          }}
          fill
        />
      </div>
      {children}
    </div>
  )
}
